function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { ActionType } from "../../enum/ActionType";
/**
 * アクション条件情報　モデル
 */

var ActionConditionInfoInstanceModel =
/**
 * コンストラクタ
 *
 */
function ActionConditionInfoInstanceModel() {
  _classCallCheck(this, ActionConditionInfoInstanceModel);

  this.ConditionNo = 0;
  this.Condition = "";
  this.ActionType = ActionType.None;
  this.IsOn = false;
  this.ActionValue = "";
};

export { ActionConditionInfoInstanceModel as default };